import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalService } from '../../@core/services/global.service';

@Injectable({
  providedIn: 'root',
})
export class SchoolService {
  lang = 'en';
  constructor(private http: HttpClient, private globalService: GlobalService) {
    this.lang = localStorage.getItem('language') || 'en';
  }
  getJourney(): Observable<any> {
    return this.globalService.get(`playground/landing/journeys`);
  }
  getJourneyData(id: number): Observable<any> {
    return this.globalService.get(
      `playground/landing/journey?journey_id=${id}`
    );
  }
  getStayInformed(email: {}): Observable<any> {
    return this.globalService.post('subscribe_to_mailing_list', email);
  }
}
